/**
 *
 * @module embeddedConfiguration
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const ConfigurationClientConfiguration = Services.Configuration.ConfigurationClientConfiguration;
const ConfigurationClientExtrasMap = Services.Configuration.ConfigurationClientExtrasMap;
const ConfigurationHostName = Services.Configuration.ConfigurationHostName;
const ServiceEndpoint = Services.ServiceEndpoint;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    boolean
} = Check.assert;

/**
 *
 * @class EmbeddedConfiguration
 *
 */
export default class EmbeddedConfiguration {

    /**
     *
     * @param {Boolean} [isFallback=false] flag to determine if the EmbeddedConfiguration
     * instance is being used as a fallback (for example, if config fetch fails)
     *
     */
    constructor(isFallback = false) {

        const errorMessage = {
            ctor: 'EmbeddedConfiguration(isFallback)',
            get isFallback() {
                return `${this.ctor} needs ConfigurationClientConfiguration instance`;
            }
        };

        boolean(isFallback, errorMessage.isFallback, InvalidArgumentException);

        const defaultConfigHostName = ConfigurationHostName.prod;
        const configHostParams = {
            dev: {
                baseUrl: 'https://dev-bam-sdk-configs.bamgrid.com/bam-sdk'
            },
            prod: {
                baseUrl: 'https://bam-sdk-configs.bamgrid.com/bam-sdk'
            }
        };

        let href = `
            {baseUrl}/
            v{configVersion}/
            {clientId}/{deviceFamily}/v{sdkVersion}/
            {deviceProfile}/{applicationRuntime}/{environment}.json
        `.replace(/(?:\n\s+)/g, '');

        if (isFallback) {
            href = href
                .replace(/\{deviceProfile\}/gi, 'default')
                .replace(/\{applicationRuntime\}/gi, 'browser');
        }

        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };

        const endpoints = {
            bootstrap: new ServiceEndpoint(
                'bootstrap',
                href,
                0,
                30,
                true,
                null,
                headers
            )
        };

        /**
         *
         * @access public
         * @type {String<SDK.Services.Configuration.ConfigurationHostName>}
         * @desc The default configuration host name to use ("dev" or "prod").
         *
         */
        this.defaultConfigHostName = defaultConfigHostName;

        /**
         *
         * @access public
         * @type {ConfigurationClientConfiguration}
         *
         */
        this.client = new ConfigurationClientConfiguration(
            new ConfigurationClientExtrasMap(configHostParams),
            defaultConfigHostName,
            endpoints
        );

    }

}



// WEBPACK FOOTER //
// ./src/configuration/embeddedConfiguration.js